import { Cell, Table, TableBody, TableHead, TableHeader, TableRow } from "@vds/tables";
import noVideo from "../../../assets/no-snapshot.jpeg";


import { Icon } from "@vds/icons";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import { Loader } from "@vds/loaders";
import statEventImage from "../../../assets/event_Stats_Evidence.png";
import ErrorTemplate from "../errorTemplate/ErrorTemplate";
import { Box } from "@mui/system";
import { TEXT } from "../../constants/errorTemplateConstants";

import {
  Base64VideoDecoder,
  convertDateFormat,
  getPriorityColor,
  getStatusColor,
  getImageObj,
  fetchEvidenceS3Url,
} from "../../utility/Utils";
import { ImageDownloadMedia } from "../../../model/mediaService";
import { useEffect, useState } from "react";
import { saveEvidenceImage } from "../../../store/actions/index.jsx";
import { EVENT_TYPES, MEDIA_TYPES } from "../../constants/commonConstants";
import { Button } from "@vds/buttons";
import { useNavigate } from "react-router-dom";
import { Badge } from "@vds/badges";
import { Pagination } from "antd";
import { AreaFloorText, EventText, SamllText, EventIdTextWrapper } from "../events/styles";
import { Body, Title } from "@vds/typography";
import { Spinner } from "react-bootstrap";
import { addIncidentList, addSelectedIncident, eventPageNumber, removeBulkSelectedIncidents, removeSelectedIncident } from "../../../store/actions";
import { Checkbox } from "@vds/checkboxes";
import NoCamera from "../../../assets/no_camera.jpg";

import "./EventsTable.scss";

const EventTable = (props) => {
  const {
    incidentList,
    clearFilters,
    isDataFiltered,
    handlePageClick,
    totalIncidentCount,
    apiLoading,
    selectedPage,
    scrollPositionRef,
    apiError,
    callfilterEventApi,
    page
  } = props;
  const navigate = useNavigate();
  const [isEventChecked, setIsEventChecked] = useState(false);
  const { incidentsList, selectedIncidentList } = useSelector((state) => state?.availableIncidentsReducer);
  const [currentPage, setCurrentPage] = useState(selectedPage ? selectedPage : 1);
  const dispatch = useDispatch();

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handlePageClick(page);
  };

  useEffect(() => {
    if (selectedPage) {
      setCurrentPage(selectedPage);
    }
  }, [selectedPage]);

  useEffect(() => {
    dispatch(addIncidentList(incidentList));
    dispatch(removeBulkSelectedIncidents());
  }, [incidentList]);

  const getTableInfo = () => {
    return incidentList?.map((incident) => {
      const {
        evidences,
        description,
        createdAt,
        applicationId,
        status,
        priority = "LOW",
        id,
        deviceLoc,
        incidentNumber,
        type,
        title,
        depId // it will soon be available from TSCORE
      } = incident;
      const areaName = deviceLoc?.area?.name ? deviceLoc?.area?.name : "NA";
      const floorName = deviceLoc?.floor?.name ? deviceLoc?.floor?.name : "NA";
      const siteName = deviceLoc?.site?.name ? deviceLoc?.site?.name : "NA";
      const isAllNA = areaName === "NA" && floorName === "NA" && siteName === "NA";
      const { formatWithTime } = convertDateFormat(createdAt);

      const imageEvidence = getImageObj(evidences, MEDIA_TYPES.IMAGE);
      const videoEvidence = getImageObj(evidences, MEDIA_TYPES.VIDEO);

      if (evidences && Array.isArray(evidences)) {
        return (
          <TableRow
            key={id || incidentNumber}
            className="eventsTableRow"
            data-testid="events_tableRow"
            onClick={() => {
              dispatch(eventPageNumber(selectedPage));
              navigate(`/eventsInfo?eventid=${id}`);
            }}
          >
            <Cell>
              <Checkbox
                name={""}
                width="auto"
                disabled={status?.toLowerCase() === "unresolved" ? false : true}
                error={false}
                selected={selectedIncidentList?.some((item) => item?.id === incident?.id)}
                onChange={(e, { selected }) => {
                  // Prevent the checkbox click from bubbling to the row which
                  // navigates away & also avoid default focus scroll jumps.
                  e.preventDefault();
                  e.stopPropagation();
                  // Capture scroll position BEFORE state changes that might re-render.
                  if (scrollPositionRef?.current !== undefined) {
                    scrollPositionRef.current = window.scrollY;
                  }
                  setIsEventChecked(selected);
                  if (selected) {
                    dispatch(addSelectedIncident(incident));
                  } else {
                    dispatch(removeSelectedIncident(incident));
                  }
                }}
              >
                {""}
              </Checkbox>
            </Cell>

            <Cell className="tableImageCell">
              <LazyLoadImage imageId={imageEvidence?.id} mediaId={imageEvidence?.mediaId} appId={applicationId} type={type} />
              <EventIdTextWrapper>
                <Body size="small" color="#6F7171">
                  Event ID : {incidentNumber ? incidentNumber : "000000000"}
                </Body>
              </EventIdTextWrapper>
            </Cell>

            <Cell>
              <EventText>{title ? title : applicationId}</EventText>
              <SamllText>{formatWithTime}</SamllText>
              <div style={{width:"10px", height:"10px"}}></div>
              <div >
                    {imageEvidence?.hasMedia && !imageEvidence?.isMediaDeleted && <Icon title="Evidence Image available" name="photo" size="large" />}
                   {"  "}
                    {videoEvidence?.hasMedia && !videoEvidence?.isMediaDeleted && <Icon title="Video available" name="video" size="XLarge" />}
                  </div>
            </Cell>
            <Cell>
              <div>
                {isAllNA ? (
                  <div>
                    <AreaFloorText>NA</AreaFloorText>
                  </div>
                ) : (
                  <div>
                    <AreaFloorText>
                      {areaName !== "NA" ? areaName : ""}
                      {areaName !== "NA" && floorName !== "NA" ? "," : ""}
                      {floorName !== "NA" ? floorName : ""}
                    </AreaFloorText>
                    <SamllText>{siteName !== "NA" ? siteName : ""}</SamllText>
                  </div>
                )}
                
              </div>
            </Cell>
            <Cell>
              <AreaFloorText>
                {description}
              </AreaFloorText>
            </Cell>
            <Cell>
              <span className="stack-vertically-eventTable">
                <Badge fillColor={getPriorityColor(priority)}>{priority === "Low" || priority === "Elevated" ? "Minor" : priority}</Badge>
              </span>
              <span className="stack-vertically-eventTable">
                <Badge fillColor={getStatusColor(status)}>{status}</Badge>
              </span>
            </Cell>
          </TableRow>
        );
      }
    });
  };
  return (
    <div>
      <div className="events-table-wrapper">
        {incidentList?.length === 0 && !apiError && (
          <div className={`incident-error${apiLoading ? " incident-error--loading" : ""}`}>
            {apiLoading ? <Loader fullscreen={false} active={apiLoading} surface="light" /> :
              <Title size="large" primitive="h3">
                No events found
              </Title>
            }
            {isDataFiltered && !apiLoading && (
              <>
                <Body size="large">Try adjusting your search or filters.</Body>
                <br></br>
                <div>
                  <Button use="secondary" onClick={clearFilters} data-testid="events_clearFilters">
                    Remove filters
                  </Button>
                </div>
              </>
            )}
          </div>
        )}
        {incidentList?.length > 0 && (
          <>
            <Table className={"events_table_ tbody tr"} striped={false} bottomLine="secondary" padding="standard">
              <TableHead>
                <TableHeader aria-label="Select events"></TableHeader>
                <TableHeader>Snapshot</TableHeader>
                <TableHeader>Event</TableHeader>
                <TableHeader>Location</TableHeader>
                <TableHeader>Info</TableHeader>
                <TableHeader>Status</TableHeader>
              </TableHead>
              <TableBody>{incidentList?.length > 0 && getTableInfo()}</TableBody>
            </Table>
            <div className="d-flex justify-content-end">
              <Pagination onChange={handlePageChange} showSizeChanger={false} defaultCurrent={currentPage} total={totalIncidentCount} />
            </div>
          </>
        )}
      </div>
      {apiError && !apiLoading && <Box
        sx={{
          height: "500px",
          marginTop: "40px",
        }}
      >
        <ErrorTemplate title={TEXT.EVENTS_ERROR} description={TEXT.EVENTS_ERROR_DESC} onRefresh={() => callfilterEventApi(page)} />
      </Box>}
    </div>
  );
};

const LazyLoadImage = ({ imageId = "", mediaId, appId, type }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const dispatch = useDispatch();
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const evidenceImages = useSelector((state) => state.imagesReducer.evidenceImages);
  const [imageUrl, setImageUrl] = useState(null);

  const [appType, setAppType] = useState(null); // useState(cvApp?.category);
  const [isImageLoading, setIsImageLoading] = useState(false);

  /*TempLogic FOr Now Later need to talk t MElvyn for CvApp Id with every event  */

  const fetchImage = async (id, type) => {
    try {
      setIsImageLoading(true);
      if (mediaId && type === EVENT_TYPES.INCIDENT) {
        const cacheKey = mediaId || id;
        const cachedUrl = evidenceImages[cacheKey];
        if (cachedUrl) {
          setImageUrl(cachedUrl);
          return;
        }
        
        const url = await ImageDownloadMedia(mediaId, activeSession, "", "evidence");
        if (url) {
          dispatch(saveEvidenceImage(cacheKey, url));
          setImageUrl(url);
        }
      }
    } catch (error) {
      console.error("Error downloading image:", error);
    } finally {
      setIsImageLoading(false);
    }
  };

  const displayImage = (imageUrl) => {
    return imageUrl ? (
      <img
        src={imageUrl}
        style={{
          cursor: imageUrl ? "pointer" : "pointer"
        }}
        className="events_td_img"
        alt="Event App"
      />
    ) : appType === "Statistics Apps" ? (
      <img
        src={statEventImage}
        style={{
          cursor: noVideo ? "pointer" : "pointer"
        }}
        className="events_td_img"
        alt="App"
      />
    ) : (
      <div
        className="no-camera-thumbnail"
        style={{ backgroundImage: `url(${NoCamera})` }}
      ></div>
    );
  };

  useEffect(() => {
    if (inView) {
      if (type === EVENT_TYPES.INCIDENT) {
        setAppType("Events Apps");
      } else {
        setAppType("Statistics Apps");
      }
      fetchImage(imageId, type);
    }
  }, [inView, imageId, mediaId]);

  return (
    <div ref={ref}>
      {isImageLoading ? (
        <div className="image-loading-placeholder">
          <Spinner />
          <div>Loading event image</div>
        </div>
      ) : (
        displayImage(imageUrl)
      )}
    </div>
  );
};

export default EventTable;
